export default __webpack_public_path__ + "static/media/celular-ecom.4b5b86f3.png";